import PublisherSelect from '../enhanced_ads/PublisherSelect/PublisherSelect';

const PublisherSelectDirective = (
  reactDirective,
  CreativeService,
  RenderService
) => {
  return reactDirective(
    PublisherSelect,
    undefined,
    {
      restrict: 'E'
    },
    {
      CreativeService,
      RenderService
    }
  );
};

PublisherSelectDirective.$inject = [
  'reactDirective',
  'CreativeService',
  'RenderService'
];

export default PublisherSelectDirective;
